export default "__VITE_ASSET__BgCsLqQr__"